import { render } from "./IconMinus.vue?vue&type=template&id=f221b9e8"
const script = {}
script.render = render

export default script